import React from "react"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {
	ProductApplication,
	cancelProductApplication,
	getProductApplicationName,
} from "../../resources/productApplication"
import {CancelApplicationModal} from "./ApplicationCancel"

interface ProductCancelModalProps {
	application: ProductApplication
	close: () => void
	onSuccess: () => void
}

export function CancelProductApplicationModal({application, close, onSuccess}: ProductCancelModalProps) {
	const accessToken = useAccessToken()
	const [state, cancel] = useAsyncResultIdle(cancelProductApplication)

	return (
		<CancelApplicationModal
			title={`Cancel Product Application for ${getProductApplicationName(application)}`}
			close={close}
			onSuccess={onSuccess}
			cancelFn={(token, reason) => cancel(token, application, reason)}
			state={state}
			accessToken={accessToken}
			warningMessage="Canceling a product application cannot be undone."
		/>
	)
}
